// Mock data for BLKPixel Technologies website

export const navLinks = [
  { label: 'Products', href: '#products' },
  { label: 'Studio (Agency)', href: '#studio' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'About Us', href: '#about' },
];

export const heroBadges = [
  { icon: 'Sparkles', label: 'AI-Powered' },
  { icon: 'Zap', label: 'Lightning Fast' },
  { icon: 'TrendingUp', label: 'Scale Without Limits' },
  { icon: 'ShieldCheck', label: 'Secure & Reliable' },
];

export const products = [
  {
    id: 'apptonomy',
    name: 'Apptonomy',
    icon: 'A',
    image: '/logos/apptonomy-logo.png',
    color: 'from-purple-500 to-violet-600',
    description: 'AI-powered development platform that builds apps from plain English.',
    tagline: 'Build apps from plain English.',
  },
  {
    id: 'honestpay',
    name: 'HonestPay',
    icon: 'H',
    image: '/logos/honestpay-logo.jpeg',
    color: 'from-green-400 to-emerald-500',
    description: 'Group payments made simple, transparent, and stress-free.',
    tagline: 'Split bills. Track payments. Stay transparent.',
  },
  {
    id: 'rapidreps',
    name: 'RapidReps',
    icon: 'R',
    image: '/logos/rapidreps-logo.png',
    color: 'from-orange-400 to-red-500',
    description: 'The Uber of personal training. Book. Train. Get Results.',
    tagline: 'The Uber of personal training.',
  },
  {
    id: 'haulazz',
    name: 'HaulAzz',
    icon: 'Truck',
    image: '/logos/haulazz-logo.png',
    color: 'from-blue-400 to-cyan-500',
    description: 'On-demand box truck rentals. Fast. Local. Affordable.',
    tagline: 'Need it now, HaulAzz.',
  },
  {
    id: 'hirepower',
    name: 'HirePower',
    icon: 'ShieldCheck',
    image: '/logos/hirepower-logo.png',
    color: 'from-cyan-400 to-blue-500',
    description: 'Federal HR automation tool for faster, smarter hiring decisions.',
    tagline: 'Federal HR technology platform.',
  },
  {
    id: 'grnbook',
    name: 'GRNBook',
    icon: 'UserCircle',
    image: '/logos/grnbook-logo.png',
    color: 'from-emerald-400 to-green-500',
    description: 'Find trusted local service pros. Book. Relax. It\'s handled.',
    tagline: 'Local services marketplace.',
  },
  {
    id: 'rayofhope',
    name: 'RayOfHope',
    icon: 'Heart',
    color: 'from-pink-400 to-rose-500',
    description: 'Giving back through technology, hope, and community.',
    tagline: 'Community-focused technology initiative.',
  },
];

export const studioServices = [
  { icon: 'Code2', title: 'Custom Software', subtitle: 'Built for Your Business' },
  { icon: 'CreditCard', title: 'Flexible Payment Plans', subtitle: 'Pay Over Time' },
  { icon: 'Rocket', title: 'End-to-End Service', subtitle: 'PayFly Support' },
  { icon: 'LifeBuoy', title: 'Ongoing Support', subtitle: 'Maintenance & Growth' },
];

export const studioReasons = [
  'Fast Turnaround',
  'Scalable Solutions',
  'Transparent Pricing',
  'Dedicated Team',
  '24/7 Support',
];

export const whyChooseCards = [
  {
    icon: 'Cpu',
    title: 'AI-Powered Innovation',
    description: 'Leverage the power of AI to build, automate, and scale faster than ever.',
  },
  {
    icon: 'Shield',
    title: 'Scalable & Secure',
    description: 'Enterprise-grade security and infrastructure built to scale with your business.',
  },
  {
    icon: 'TrendingUp',
    title: 'Built for Growth',
    description: 'Solutions designed to increase efficiency, revenue, and customer satisfaction.',
  },
  {
    icon: 'Wallet',
    title: 'Affordable & Flexible',
    description: 'Flexible payment options and plans that fit businesses of all sizes.',
  },
  {
    icon: 'Layers',
    title: 'All-in-One Platform',
    description: 'From development to deployment to support \u2014 we\'ve got you covered.',
  },
  {
    icon: 'Users',
    title: 'Real Human Support',
    description: 'We\'re here when you need us. Real people. Real solutions.',
  },
];

export const pricingPlans = [
  {
    name: 'Starter',
    subtitle: 'Perfect for getting started',
    price: '$199',
    period: '/month',
    popular: false,
    features: [
      'Up to 2 Projects',
      'AI Credits Included',
      'Community Support',
      'Basic Exports',
    ],
    cta: 'Get Started',
  },
  {
    name: 'Pro',
    subtitle: 'Built for professionals',
    price: '$499',
    period: '/month',
    popular: true,
    features: [
      'Unlimited Projects',
      'More AI Credits',
      'Priority Support',
      'Advanced Exports',
    ],
    cta: 'Get Pro Plan',
  },
  {
    name: 'Agency',
    subtitle: 'For teams & agencies',
    price: '$999',
    period: '/month',
    popular: false,
    features: [
      'Team Collaboration',
      'White Label (Coming Soon)',
      'Dedicated Support',
      'Custom Integrations',
    ],
    cta: 'Contact Sales',
  },
];

export const companyStats = [
  { value: '10K+', label: 'Projects Built' },
  { value: '3K+', label: 'Happy Customers' },
  { value: '99.9%', label: 'Uptime' },
  { value: '24/7', label: 'Support' },
];

export const trustedCompanies = [
  { name: 'FITZONE', subtitle: 'GYM & FITNESS' },
  { name: 'CleanMaster', subtitle: 'SERVICES' },
  { name: 'QuickPay', subtitle: 'FINTECH' },
  { name: 'LAWSON', subtitle: 'LEGAL GROUP' },
  { name: 'BrightPath', subtitle: 'EDUCATION' },
];

export const footerColumns = {
  Products: ['Apptonomy', 'HonestPay', 'RapidReps', 'HaulAzz', 'HirePower', 'GRNBook', 'RayOfHope'],
  'Studio (Agency)': ['Services', 'Our Process', 'Case Studies', 'Pricing', 'Book a Call'],
  Resources: ['Blog', 'Templates', 'Documentation', 'Help Center', 'Community'],
  Company: ['About Us', 'Our Mission', 'Careers', 'Contact Us', 'Partners'],
};

export const recentProjectsMock = [
  { icon: 'ShoppingBag', name: 'Uber-Style Cleaning App', time: 'Updated 2h ago', color: 'from-purple-500 to-pink-500' },
  { icon: 'Dumbbell', name: 'Fitness Marketplace', time: 'Updated 3h ago', color: 'from-orange-500 to-red-500' },
  { icon: 'Wallet', name: 'Fintech Wallet App', time: 'Updated 1d ago', color: 'from-blue-500 to-cyan-500' },
];
